import { Alert } from "react-bootstrap";
import CodeSlide from "../../components/Slides/templates/CodeSlide";
import DefaultSlide from "../../components/Slides/templates/DefaultSlide";
import ImageSlide from "../../components/Slides/templates/ImageSlide";
import TitleSlide from "../../components/Slides/templates/TitleSlide";
import { ISlideObject } from "../../components/Slides/templates/ISlideObject";

export default function S00P00({ reveal }: ISlideObject) {
  return (
    <>
      <TitleSlide
        title="TI8512 - Desarrollo Ágil de Aplicaciones Web"
        subtitle="En la esquina inferior derecha puedes moverte al siguiente slide."
      />
      <DefaultSlide title="¡Excelente!">
        <div>
          <p>
            En esta primera parte aprenderás a moverte en esta presentación.
          </p>
          <p>
            Si estás desde tu dispositivo móvil puedes utilizar el gesto 'swipe'
            para moverte a otro slide, o bien, utilizar las flechas de tu
            teclado para moverte.
          </p>
          <img
            alt="Imagen con flechas de teclado"
            width="100px"
            src="/images/S01/arrows.jpg"
          />
          <img
            alt="Imagen representativa de gesto swipe"
            className="ps-3"
            width="100px"
            src="/images/S01/swipe.jpg"
          />
        </div>
      </DefaultSlide>
      <section>
        <DefaultSlide title="¡Muy bien!">
          <div>
            <p>
              Ahora debes aprender a navegar verticalmente. Estas presentaciones
              permiten desplazarse horizontalmente (de izquierda a derecha) y de
              forma vertical (de arriba hacia abajo).
            </p>
            <p>
              Para efectos de este curso, cada contenido de la semana se verá de
              forma vertical.
            </p>
            <img
              className="center"
              alt="Flecha abajo"
              src="/images/S01/arrowdown.png"
              width="100"
            />
          </div>
        </DefaultSlide>
        <DefaultSlide title="¡Genial!">
          <div>
            <p>Excelente, ya lograste desplazarte verticalmente.</p>
            <p>
              Ahora puedes volver hacia arriba o desplazarte a la siguiente
              sección hacia la derecha.
            </p>
          </div>
        </DefaultSlide>
      </section>
      <section>
        <DefaultSlide title="¿Qué veras en las presentaciones?">
          <img
            className="center"
            alt="Flecha abajo"
            src="/images/S01/arrowdown.png"
          />
        </DefaultSlide>
        <CodeSlide language="js" title="Fragmentos de código">
          {`import React, { useState } from 'react';
function Example() {
  const [count, setCount] = useState(0);
  return ( ...  );
}`}
        </CodeSlide>
        <DefaultSlide title="Sobre esta presentación">
          <div>
            <p>
              Para hacer presentaciones web tan fantásticas como esta,
              utilizamos una herramienta llamada Reveal.JS.
            </p>
            <Alert variant="info">
              Accede al siguiente link y completa el tutorial de la herramienta para conocer sobre más funcionalidades. Vamos a utilizar muchas de ellas a lo largo del curso.
            </Alert>
            <a target="_blank" rel="noreferrer" href="https://revealjs.com/demo/">Reveal JS Demo</a>
            <p>No le tienes que prestar atención al código, sólamente familiarizarte con la herramienta.</p>
          </div>
        </DefaultSlide>
      </section>
      <ImageSlide image="/images/S01/goodjob.gif" title="¡Muy bien!">
        <p>Haz completado el primer tutorial!</p>
        {/* <button className="btn btn-success">Marcar como completo</button> */}
      </ImageSlide>
    </>
  );
}
